
export class ForeignAccountDataDto {
    id: number;
    bornAmerican: boolean;
    naturalizedAmerican: boolean;
    partnerInAmericanCompany: boolean;
    hasGreenCard: boolean;
    taxResidenceEUA: boolean;
    identificationNumber: string;


    setBornAmerican(event, value: boolean) {
        if (event.target.checked) this.bornAmerican = value;
    }

    setNaturalizedAmerican(event, value: boolean) {
        if (event.target.checked) this.naturalizedAmerican = value;
    }

    setPartnerInAmericanCompany(event, value: boolean) {
        if (event.target.checked) this.partnerInAmericanCompany = value;
    }

    setHasGreenCard(event, value: boolean) {
        if (event.target.checked) this.hasGreenCard = value;
    }

    setTaxResidenceEUA(event, value: boolean) {
        if (event.target.checked) this.taxResidenceEUA = value;
    }
}
